/** Shared option lists and formatters for the Accounts tabs. */

export const PAYMENT_STATUS_OPTIONS = [
  { label: "Paid", value: "paid" },
  { label: "Not Paid", value: "notPaid" },
];

export const FREQUENCY_OPTIONS = [
  { label: "Monthly", value: "monthly" },
  { label: "Quarterly", value: "quarterly" },
  { label: "Annual", value: "annual" },
];

export const RECURRING_STATUS_OPTIONS = [
  { label: "Active", value: "active" },
  { label: "Paused", value: "paused" },
];

export const DAY_MODE_OPTIONS = [
  { label: "Single", value: "single" },
  { label: "Multiple", value: "multiple" },
];

export const LEDGER_TYPE_OPTIONS = [
  { label: "Inward", value: "inward" },
  { label: "Outward", value: "outward" },
  { label: "Internal Transfer", value: "internalTransfer" },
];

export const LEDGER_SOURCE_OPTIONS = [
  { label: "Manual", value: "MANUAL" },
  { label: "COD Repayment", value: "REPAY" },
  { label: "Company Expense", value: "EXPENSE" },
  { label: "Payout", value: "PAYOUT" },
  { label: "Cash Deposit", value: "DEPOSIT" },
  { label: "Salary", value: "SALARY" },
  { label: "Invoice", value: "INVOICE" },
];

export const PAYEE_TYPE_OPTIONS = [
  { label: "Office Staff", value: "staff" },
  { label: "Rider", value: "rider" },
];

export const SALARY_STATUS_OPTIONS = [
  { label: "Pending", value: "pending" },
  { label: "Approved", value: "approved" },
  { label: "Transferred", value: "transferred" },
  { label: "On Hold", value: "onHold" },
  { label: "Rejected", value: "rejected" },
];

/**
 * The fixed invoice fee schedule from the supplied invoice.pdf — mirrors
 * INVOICE_SCHEDULE_FIELDS in the backend's Accounts/constants.js.
 */
export const INVOICE_SCHEDULE_FIELDS = [
  // Money like every other line: the amount billed for the period's deliveries,
  // not how many there were, so it reaches the subtotal (client request, Sep 2026).
  { name: "completedDeliveries", label: "Completed Deliveries" },
  { name: "pickupAdminFee", label: "Pickup Admin Fee" },
  { name: "dropOffAdminFee", label: "Drop-off Admin Fee" },
  { name: "bikeAdminFee", label: "Bike Admin Fee" },
  { name: "adminIncentives", label: "Admin Incentives" },
  { name: "operationsFee", label: "Operations Fee" },
  { name: "incentive", label: "Incentive" },
  { name: "tips", label: "Tips" },
  { name: "compensations", label: "Compensations" },
  // sign: -1 — reduces the invoice. Mirrors INVOICE_DEDUCTION_FIELDS in the
  // backend's Accounts/constants.js; the two must agree or the live preview
  // disagrees with the saved total.
  { name: "deductions", label: "Deductions", sign: -1 },
  { name: "omanizationDeductions", label: "Omanization Deductions", sign: -1 },
  { name: "positiveAdjustment", label: "Positive Adjustment" },
];

/** Oman standard VAT rate. */
export const VAT_PERCENT = 5;

/** OMR is a 3-decimal currency. */
export function formatOmr(value) {
  if (value === null || value === undefined || value === "") return "—";
  return Number(value).toLocaleString("en-US", {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
  });
}
